<template>
    <div class="page_wrap">
        <div class="box_wrap">
            <div
                class="content_wrap"
                v-if="setting && setting.settings">
                <div
                    class="print_wrap"
                    :style="setting.settings.show_top_height === 1 ? `margin-top: ${setting.topHeight}mm` : 'margin-top: 5mm;'">
                    <div
                        class="flex justify-between items-top"
                        v-if="setting.settings.show_logo || setting.settings.show_title">
                        <div>
                            <img
                                v-if="setting.settings.show_logo"
                                class="print_logo"
                                :src="form.logoUrl">
                        </div>
                        <div
                            v-if="setting.settings.show_title"
                            :style="titleFont"
                            class="print_title">
                            {{ form.contractTitle }}
                        </div>
                        <div style="visibility: hidden;">
                            <img
                                v-if="setting.settings.show_logo"
                                class="print_logo"
                                :src="form.logoUrl">
                        </div>
                    </div>
                    <div class="sell-print-clientinfo">
                        <div class="sell-clientinfo-item flex">
                            <div class="info-item" v-if="setting.settings.show_club">
                                <label>{{ $t('Client.club') }}：</label>
                                <span>{{ form.club }}</span>
                            </div>
                            <div class="info-item">
                                <label>{{ $t('Contract.number') }}：</label>
                                <span>
                                    {{ form.contractNum }}
                                    <i v-if="setting.settings.show_contract_type">
                                        ({{ form.contractType }})
                                    </i>
                                </span>
                            </div>
                            <div class="info-item">
                                <label>{{ $t('Member.saler') }}：</label>
                                <span>{{ form.salesStaffNickname }}</span>
                            </div>
                        </div>
                        <div class="sell-clientinfo-item flex">
                            <div class="info-item">
                                <label>{{ $t('Sell.Print.memberName') }}</label>
                                <span>{{ form.clientName }}</span>
                            </div>
                            <div class="info-item">
                                <label>{{ $t('Sell.Print.gender') }}</label>
                                <span>{{ form.clientGender }}</span>
                            </div>
                            <div class="info-item">
                                <label>{{ $t('Sell.Print.phone') }}</label>
                                <span>{{ form.clientPhone }}</span>
                            </div>
                        </div>
                        <div class="sell-clientinfo-item flex">
                            <div class="info-item">
                                <label>{{ $t('Sell.Print.ID_number') }}</label>
                                <span>{{ form.certNum }}</span>
                            </div>
                            <div class="info-item">
                                <label>{{ $t('Common.card_number') }}：</label>
                                <span>{{ form.cardNum }}</span>
                            </div>
                            <div class="info-item" v-if="activeName === 'personal'">
                                <label>{{ $t('Course.coach') }}：</label>
                                <span>{{ form.coachNickname }}</span>
                            </div>
                            <div class="info-item" v-else>
                                <label></label>
                                <span></span>
                            </div>
                        </div>
                        <div class="sell-clientinfo-item flex">
                            <div class="info-item info-w-full">
                                <label>{{ $t('Sell.Print.Home_Address') }}</label>
                                <span>{{ form.homeAddress }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 类型不同数据不同 -->
                    <table v-if="activeName === 'member'" class="sell-print-table">
                        <tr>
                            <th>{{ $t('Contract.card_name') }}</th>
                            <th>{{ $t('Sell.Charge.base_amt') }}</th>
                            <th v-if="setting.settings.show_discount">{{ $t('Sell.Print.discounts') }}</th>
                            <th>{{ $t('Sell.Print.receivable') }}</th>
                        </tr>
                        <tr>
                            <td>{{ tableData[0].itemName }}</td>
                            <td>{{ tableData[0].baseAmt }}</td>
                            <td v-if="setting.settings.show_discount">{{ tableData[0].discountAmt }}</td>
                            <td>{{ tableData[0].payableAmt }}</td>
                        </tr>
                    </table>

                    <table v-if="activeName === 'personal'" class="sell-print-table">
                        <tr>
                            <th>{{ $t('Course.name') }}</th>
                            <th>{{ $t('Sell.Print.Number_of_classes') }}</th>
                            <th>{{ $t('Sell.Charge.base_amt') }}</th>
                            <th v-if="setting.settings.show_discount">{{ $t('Sell.Print.discounts') }}</th>
                            <th>{{ $t('Sell.Print.receivable') }}</th>
                        </tr>
                        <tr>
                            <td>{{ tableData[0].itemName }}</td>
                            <td>{{ tableData[0].lessonCredit }}</td>
                            <td>{{ tableData[0].baseAmt }}</td>
                            <td v-if="setting.settings.show_discount">{{ tableData[0].discountAmt }}</td>
                            <td>{{ tableData[0].payableAmt }}</td>
                        </tr>
                    </table>

                    <table v-if="activeName === 'locker'" class="sell-print-table">
                        <tr>
                            <th>{{ $t('Common.store') }}</th>
                            <th>{{ $t('Sell.Print.Lease_cabinet_area') }}</th>
                            <th>{{ $t('Reception.Third.number') }}</th>
                            <th>{{ $t('Week.lease_period2') }}</th>
                            <th>{{ $t('Sell.Charge.base_amt') }}</th>
                            <th v-if="setting.settings.show_discount">{{ $t('Sell.Print.discounts') }}</th>
                            <th>{{ $t('Sell.Print.receivable') }}</th>
                        </tr>
                        <tr>
                            <td>{{ tableData[0].storeName }}</td>
                            <td>{{ tableData[0].storeAreaName }}</td>
                            <td>{{ tableData[0].lockerCode }}</td>
                            <td>{{ tableData[0].lease }}</td>
                            <td>{{ tableData[0].baseAmt }}</td>
                            <td v-if="setting.settings.show_discount">{{ tableData[0].discountAmt }}</td>
                            <td>{{ tableData[0].payableAmt }}</td>
                        </tr>
                    </table>

                    <table v-if="activeName === 'cardsCon'" class="sell-print-table">
                        <tr>
                            <th>{{ $t('Card.card1') }}</th>
                            <th>{{ $t('Sell.Print.Amount_of_value') }}</th>
                            <th>{{ $t('Sell.Charge.base_amt') }}</th>
                            <th v-if="setting.settings.show_discount">{{ $t('Sell.Print.discounts') }}</th>
                            <th>{{ $t('Sell.Print.receivable') }}</th>
                        </tr>
                        <tr>
                            <td>{{ tableData[0].itemName }}</td>
                            <td>{{ tableData[0].cardCredit }}</td>
                            <td>{{ tableData[0].baseAmt }}</td>
                            <td v-if="setting.settings.show_discount">{{ tableData[0].discountAmt }}</td>
                            <td>{{ tableData[0].payableAmt }}</td>
                        </tr>
                    </table>

                    <div class="sell-print-desc">
                        <div class="sell-desc-item flex justify-between">
                            <div
                                class="item-info item-w-full"
                                v-if="['member', 'cardsCon'].includes(activeName)">
                                <label>{{ $t('Contract.support_store') }}：</label>
                                <span>{{ form.supportStores }}</span>
                            </div>
                        </div>
                        <div class="sell-desc-item flex justify-between">
                            <div class="item-info">
                                <label>{{ $t('Sell.Print.contract_life') }}</label>
                                <span>{{ form.contractValidity }}</span>
                            </div>
                            <div class="item-info" v-if="activeName === 'member'">
                                <label>{{ $t('Member.open_card_method') }}：</label>
                                <span>{{ form.activeCardWay }}</span>
                            </div>
                        </div>
                        <div class="sell-desc-item flex justify-between">
                            <div class="item-info">
                                <label>{{ $t('Sell.Pay.title') }}：</label>
                                <span>{{ form.payMethod }}</span>
                            </div>
                            <div class="item-info" v-if="activeName !== 'locker'">
                                <label v-if="activeName !== 'personal'">{{ $t('Member.open_card_store') }}：</label>
                                <label v-else-if="activeName === 'personal'">{{ $t('Member.sign_store') }}：</label>
                                <span>{{ form.storeName }}</span>
                            </div>
                        </div>
                        <div class="sell-desc-item flex justify-between">
                            <div class="item-info">
                                <label v-if="activeName === 'subscription'">{{ $t('Sell.Print.Total_Deposit_Payment') }}：</label>
                                <label v-else>{{ $t('Sell.Print.Total_amount_paid') }}：</label>
                                <span>{{ form.paidAmt }}</span>
                            </div>
                        </div>
                        <div class="sell-desc-item flex justify-between">
                            <div class="item-info item-w-full">
                                <label>{{ $t('Common.remark') }}：</label>
                                <span>{{ form.remark }}</span>
                            </div>
                        </div>
                        <div
                            class="sell-desc-item flex justify-between"
                            v-if="setting.settings.show_sign_1 || setting.settings.show_sign_2">
                            <div class="item-info" v-if="setting.settings.show_sign_1">
                                <label>{{ $t('Sell.Print.Member_signature') }}：</label>
                                <span></span>
                            </div>
                            <div class="item-info" v-if="setting.settings.show_sign_2">
                                <label>{{ $t('Client.club') }}：</label>
                                <span></span>
                            </div>
                        </div>
                        <div
                            class="sell-desc-item flex justify-between"
                            v-if="setting.settings.show_sign_1 || setting.settings.show_sign_2">
                            <div class="item-info" v-if="setting.settings.show_sign_1">
                                <label>{{ $t('Contract.Desc.date_of_signing') }}：</label>
                                <span>{{ form.signedDate }}</span>
                            </div>
                            <div class="item-info" v-if="setting.settings.show_sign_2">
                                <label>{{ $t('Contract.Desc.date_of_signing') }}：</label>
                                <span>{{ form.signedDate }}</span>
                            </div>
                        </div>
                        <div
                            v-if="setting.settings.show_contract"
                            class="sell-desc-item flex justify-between">
                            <div class="item-info item-w-full print-club-rules">
                                <label>{{ $t('Sell.Print.Club_Constitution') }}：</label>
                                <span v-html="form.charter"></span>
                                <!-- <span>{{ form.charter }}</span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: [],
    data() {
        return {
            activeName: this.$route.query.activeName,
            contractNum: this.$route.query.contractNum,
            form: {},
            setting: {},
            tableData: [],
            titleFont: 'font-size: 18px',
        };
    },
    methods: {
        fetchUrl() {
            let id;
            if (this.activeName === 'member') id = 1;
            else if (this.activeName === 'personal') id = 2;
            else if (this.activeName === 'locker') id = 3;
            else if (this.activeName === 'cardsCon') id = 4;
            else if (this.activeName === 'subscription') id = 6;
            API.get(`contract/setting/${id}`).then(res => {
                this.setting = res;
                const num = 18 * res.scaling / 100;
                this.titleFont = `font-size: ${num}px`;
            });
        },
        fetchData() {
            API.get(`contract/common/${this.contractNum}/preview`)
            .then(res => {
                let item;
                this.form = res;
                this.setting = res.setting;
                if (this.activeName === 'member') {
                    item = {
                        itemName: res.itemName,
                        baseAmt: res.baseAmt,
                        discountAmt: res.discountAmt,
                        payableAmt: res.payableAmt,
                    };
                } else if (this.activeName === 'personal') {
                    item = {
                        itemName: res.itemName,
                        baseAmt: res.baseAmt,
                        lessonCredit: res.lessonCredit,
                        discountAmt: res.discountAmt,
                        payableAmt: res.payableAmt,
                    };
                } else if (this.activeName === 'locker') {
                    item = {
                        storeName: res.storeName,
                        storeAreaName: res.storeAreaName,
                        lockerCode: res.lockerCode,
                        lease: res.lease,
                        baseAmt: res.baseAmt,
                        discountAmt: res.discountAmt,
                        payableAmt: res.payableAmt,
                    };
                } else if (this.activeName === 'cardsCon') {
                    item = {
                        itemName: res.itemName,
                        cardCredit: res.cardCredit,
                        baseAmt: res.baseAmt,
                        discountAmt: res.discountAmt,
                        payableAmt: res.payableAmt,
                    };
                }
                this.tableData.push(item);
            });
        },
    },
    created() {
        this.fetchData();
        // this.fetchUrl();
    },
};
</script>

<style lang="scss">
html {
    padding: 40px;
    background: #999;
}
body {
    margin: 0 auto;
    padding: 0 1cm 1cm;
    width: 21cm;
    background: #fff;
    height: initial;
    min-width: initial;
    min-height: 29.5cm;
    box-sizing: border-box;
    box-shadow: 0 0 1in -10px rgba(0,0,0,.5);
}
.page_wrap {
    min-height: 100%;
    position: relative;

    i {
        font-style: normal;
    }
}
.box_wrap {
    position: relative;
}
.content_wrap {
    padding: 1px;
}

table {
    width: 100%;
    color: #4c4c4c;
    border: 1px solid #e6e6e6;
    border-radius: 3px;
    background: #fff;
}
tr {
    text-align: center;
}
th, td {
    font-size: 13px;
}
th {
    font-weight: 400;
    padding: 10px;
    border-left: 1px solid #e6e6e6;
    &:first-child {
        border-left: none;
    }
}
td {
    height: 20px;
    padding: 10px;
    border-left: 1px solid #e6e6e6;
    border-top: 1px solid #e6e6e6;
    color: grey;
    &:first-child {
        border-left: none;
    }
}
tr {
    border-bottom: 1px solid #e6e6e6;
}
thead {
    td {
        border-top: none;
    }
}

.print_logo {
    max-width: 100px;
    max-height: 60px;
    margin-bottom: 10px;
}
.print_title {
    font-weight: 500;
    margin-bottom: 20px;
}
.info-item {
    color: #000;
    width: 33.33%;
    margin-bottom: 16px;
    &:last-child {
        padding-bottom: 0;
    }
    label {
        display: inline-block;
        width: 7.2em;
        text-align: right;
    }
    span {
        display: inline-block;
        padding-right: 5px;
    }
}
.info-w-full {
    width: 100%;
}
.sell-print-table {
    margin-bottom: 15px;
    th {
        color: #4c4c4c;
        font-weight: 400;
        background: #fafafa;
    }
}
.item-info {
    color: #000;
    width: 50%;
    margin-bottom: 12px;
    display: flex;
    align-items: flex-start;
    &:last-child {
        padding-bottom: 0;
    }
    label {
        display: inline-block;
        width: 7.2em;
        text-align: right;
        flex: 0 0 auto;
        line-height: 1.5;
    }
    span {
        display: inline-block;
        padding-right: 5px;
        line-height: 1.5;
    }
}
.item-w-full {
    width: 100%;
}
.print-club-rules {
    p {
        margin-top: 0;
        margin-bottom: 5px;
    }
}
@media print {
    * {
        color: #000 !important;
        text-shadow: none !important;
        background: 0 0 !important;
        box-shadow: none !important;
    }
    html {
        padding: 0;
    }
    body {
        width: 100%;
        margin: 0;
        padding: 0 1cm;
        font-size: 9pt;
    }
    @page {
        margin:0;
    }
    img {
        max-width: 100% !important;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    img {
        page-break-after: avoid;
        page-break-inside: avoid;
    }
    table {
        page-break-inside: avoid;
    }
    .print_wrap a {
        font-weight: 700;
        text-decoration: none;
    }
    .print_wrap a[href^=http]:after {
        content: " [" attr(href) "] ";
        font-size: 10pt;
        font-weight: 400;
    }
    .print_wrap a[href^="#"]:after {
        content: "";
    }
    .print-hide{
        display: none;
    }
    .print-show{
        display: block;
    }
}
</style>
